import React from 'react';
import { Wifi, Battery } from 'lucide-react';

/**
 * StatusBar component that displays a mobile status bar with time, wifi, and battery
 * Adapted from mockup-magic-ebook repository
 */
const StatusBar = () => {
  // Get current time in 12-hour format
  const currentTime = new Date().toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  return (
    <div className="flex justify-between items-center px-4 py-1 text-xs bg-transparent absolute top-0 left-0 right-0 z-10">
      <span className="font-medium">{currentTime}</span>
      <div className="flex items-center gap-1">
        <Wifi size={14} />
        <Battery size={14} />
      </div>
    </div>
  );
};

export default StatusBar; 